import { MapPin, MessageSquare, EyeOff } from "lucide-react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
const icons = [MapPin, MessageSquare, EyeOff];
export function Problem() {
  const t = useT();
  return <section id="problem" className="bg-[#FAFBFC] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="max-w-2xl text-2xl font-bold text-[#0F172A] sm:text-3xl">
            {t.problem.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#64748B]">
            {t.problem.lead}
          </p>
        </Reveal>
        <ul className="mt-12 grid gap-5 md:grid-cols-3">
          {t.problem.cards.map((card, i) => {
          const Icon = icons[i] ?? icons[0];
          return <Reveal as="li" key={card.title} delay={i * 60}>
                <div className="group h-full rounded-2xl border border-black/5 bg-white p-6 shadow-[0_1px_2px_rgba(10,37,57,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_32px_rgba(10,37,57,0.08)] motion-reduce:hover:translate-y-0">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl text-white" style={{
                backgroundImage: "linear-gradient(135deg,#3B82F6,#93C5FD)"
              }}>
                    <Icon size={20} aria-hidden />
                  </span>
                  <h3 className="mt-5 text-base font-semibold text-[#0F172A]">{card.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#94A3B8]">{card.body}</p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}